import React from "react";
import { api } from "./api";
// Shared data hook and status elements for the public pages and the Blog.
export function useData<T>(url: string) {
  const [value, set] = React.useState<T | null>(null),
    [error, setError] = React.useState("");
  React.useEffect(() => {
    let active = true;
    set(null);
    setError("");
    api<T>(url)
      .then((v) => {
        if (active) set(v);
      })
      .catch((e) => {
        if (active) setError(e.message);
      });
    return () => {
      active = false;
    };
  }, [url]);
  return { value, error };
}
export function Failure({ text }: { text: string }) {
  return text ? (
    <p role="alert" className="er-error">
      {text}
    </p>
  ) : null;
}
export function Loading() {
  return (
    <p className="er-loading" role="status">
      Loading…
    </p>
  );
}
export function useTitle(title: string) {
  React.useEffect(() => {
    document.title = title;
    return () => {
      document.title = "idecRxiv - Research, Inside the Research and Blog";
    };
  }, [title]);
}
export function formatDate(iso: string | null) {
  return iso
    ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
    : "";
}
